import React, { useState } from 'react'
import Layout from '../../Component/layout/main-layout'
import { useTranslation } from 'react-i18next'
import LotAngle from '../../Images/icons/LotAngle.svg'
import layoutBgImg from '../../Images/layout/services.jpg'
import { lawHelp } from '../../data'
import LawHelpTable from './law-help-table'
import ServicesLayout from '../../Component/layout/services-layout'
import GlobalLayout from '../../Component/layout/global-layout'

const LawHelp = () => {
    const { t } = useTranslation()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    const openModal = (content) => {
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setModalContent(null);
    };

    return (
        <GlobalLayout
            title={`${t('law_help')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Порядок приема граждан, Raýatlaryň jemgyýetçilik kabul edişligi,
                      Rayatlaryn kabul edilshigi, Kazyyetin kabul edis wagty"
        >
            <div className="mb-20">
                <Layout
                    title={t('law_help')}
                    layoutBgImg={layoutBgImg}
                />

                <ServicesLayout />

                <div className='bg-white dark:bg-dark-box mx-4 xxl:mx-12 
                                xxxl:mx-32 xxxxl:mx-64 xxxxxl:mx-[400px]                             
                                xxxxxxl:mx-[650px] xxxxxxxl:mx-[1600px]
                                xxxxxxxxl:mx-[2400px]'>

                    <div className="grid grid-cols-1 md:grid-cols-2 
                                xl:grid-cols-3 gap-4 p-4 xl:p-8">
                        {lawHelp?.map((d, id) => (
                            <div
                                key={id}
                                className="flex gap-2 p-3 rounded-md bg-secondary shadow-md 
                                           border border-secondary dark:border-dark-border 
                                           dark:bg-dark-box dark:text-dark-text 
                                           cursor-pointer transition-transform duration-500 
                                           ease-out hover:scale-[1.01] hover:shadow-xl"
                                onClick={() => openModal(d)}
                            >
                                <img src={LotAngle} alt="undefined" />
                                {d.title}
                            </div>
                        ))}
                    </div>
                </div>

                {isModalOpen && (
                    <LawHelpTable
                        data={modalContent}
                        closeModal={closeModal}
                    />
                )}
            </div>
        </GlobalLayout>
    );
}

export default LawHelp;
